import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { api, ApiError } from './api';
import { Login } from './pages/Login';
import { Layout } from './layout/Layout';
import { Dashboard } from './pages/Dashboard';
import { CalendarsPage } from './pages/Calendars';
import { EventsPage } from './pages/Events';
import { EventDetail } from './pages/EventDetail';
import { AdminPage } from './pages/Admin';
import { AppPasswordsPage } from './pages/AppPasswords';
import { CalDavInfoPage } from './pages/CalDavInfo';
import { SettingsPage } from './pages/Settings';
import { CalendarViewPage } from './pages/CalendarView';
import { NotificationsPage } from './pages/Notifications';
import { SubscriptionsPage } from './pages/Subscriptions';
import { FreeBusyPage } from './pages/FreeBusy';

export interface Me {
  id: string;
  email: string;
  name?: string | null;
  role: 'ADMIN' | 'USER';
  organizerEmail: string;
}

export default function App() {
  const [me, setMe] = useState<Me | null | undefined>(undefined);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get<Me>('/api/auth/me')
      .then((u) => setMe(u))
      .catch((err) => {
        if (err instanceof ApiError && err.status === 401) setMe(null);
        else setMe(null);
      });
  }, []);

  if (me === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center text-ink-secondary">Lade …</div>
    );
  }

  if (!me) {
    if (location.pathname !== '/login') {
      return <Navigate to="/login" replace />;
    }
    return <Login onLogin={(u) => setMe(u)} />;
  }

  return (
    <Layout me={me} onLogout={() => { setMe(null); navigate('/login'); }}>
      <Routes>
        <Route path="/" element={<Dashboard me={me} />} />
        <Route path="/calendar" element={<CalendarViewPage />} />
        <Route path="/calendars" element={<CalendarsPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/subscriptions" element={<SubscriptionsPage />} />
        <Route path="/freebusy" element={<FreeBusyPage />} />
        <Route path="/events/:id" element={<EventDetail />} />
        <Route path="/app-passwords" element={<AppPasswordsPage />} />
        <Route path="/settings" element={<SettingsPage me={me} onUpdate={setMe} />} />
        <Route path="/caldav-info" element={<CalDavInfoPage me={me} />} />
        <Route path="/caldav" element={<CalDavInfoPage me={me} />} />
        <Route path="/admin" element={<AdminPage me={me} />} />
        <Route path="/login" element={<Navigate to="/" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}

function NotFound() {
  return (
    <div className="card text-center text-ink-secondary">Seite nicht gefunden.</div>
  );
}
